import _toConsumableArray from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import _asyncToGenerator from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.regexp.replace.js";
export var dialog = {
  props: {
    onComplete: {
      type: Function,
      default: function _default() {}
    },
    requiresConfirmation: {
      type: Boolean,
      default: false
    },
    confirmationDialogTitle: {
      type: String,
      default: ''
    },
    confirmationDialogMessage: {
      type: String,
      default: ''
    }
  },
  methods: {
    // following method is REQUIRED
    // (don't change its name --> "show")
    show: function show() {
      this.$refs.dialog.show();
    },
    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide: function hide() {
      if (typeof this.onClose === 'function') {
        this.onClose.apply(this, arguments);
      }

      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    },
    onDialogHide: function onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide');
    },
    hideLoading: function hideLoading() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hideLoading();
      }
    },
    showLoading: function showLoading(text) {
      if (this.$refs.dialog) {
        this.$refs.dialog.showLoading(text);
      }
    },
    getConfirmationTitle: function getConfirmationTitle() {
      return this.confirmationDialogTitle;
    },
    getConfirmationMessage: function getConfirmationMessage() {
      return this.confirmationDialogMessage;
    },
    onConfirmed: function onConfirmed() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof _this.onComplete === 'function')) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return _this.onComplete.apply(_this, _toConsumableArray(_arguments));

              case 3:
                _context.next = 7;
                break;

              case 5:
                _context.next = 7;
                return Promise.resolve();

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onOKClick: function onOKClick() {
      var _this2 = this;

      var args = arguments;

      if (this.requiresConfirmation) {
        this.openDialog('UserConfirmationDialog', {
          title: this.getConfirmationTitle(),
          message: this.getConfirmationMessage(),
          html: true,
          confirmTimeout: 0,
          onConfirm: function onConfirm() {
            _this2.showLoading();

            _this2.onConfirmed.apply(_this2, _toConsumableArray(args)).then(function () {
              // on OK, it is REQUIRED to
              // emit "ok" event (with optional payload)
              // before hiding the QDialog
              _this2.$emit('ok'); // or with payload: this.$emit('ok', { ... })
              // then hiding dialog
              // this.hide(arguments)


              _this2.hide();
            }).catch(function () {}).finally(_this2.hideLoading);
          }
        });
      } else {
        this.showLoading();
        this.onConfirmed.apply(this, _toConsumableArray(args)).then(function () {
          // on OK, it is REQUIRED to
          // emit "ok" event (with optional payload)
          // before hiding the QDialog
          _this2.$emit('ok'); // or with payload: this.$emit('ok', { ... })
          // then hiding dialog


          _this2.hide(args);
        }).catch(function () {}).finally(this.hideLoading);
      }
    },
    onCancelClick: function onCancelClick() {
      // we just need to hide dialog
      this.hide(arguments);
    }
  }
};
export var timeframeUtils = {
  methods: {
    getTimeframeMask: function getTimeframeMask(timeframe) {
      return timeframe.replace(/y|m|d/g, '#');
    },
    getReadableTimeframe: function getReadableTimeframe(timeframe) {
      switch (timeframe) {
        case 'today':
          return this.$t('timeframe.today');

        case 'yesterday':
          return this.$t('timeframe.yesterday');

        case 'week_this':
          return this.$t('timeframe.this_week');

        case 'month_this':
          return this.$t('timeframe.this_month');

        case 'year_this':
          return this.$t('timeframe.this_year');

        case 'week_last':
          return this.$t('timeframe.last_week');

        case 'month_last':
          return this.$t('timeframe.last_month');

        case 'days_7':
          return this.$t('timeframe.last_7_days');

        case 'days_15':
          return this.$t('timeframe.last_15_days');

        case 'days_30':
          return this.$t('timeframe.last_30_days');

        case 'months_3':
          return this.$t('timeframe.last_3_months');

        case 'months_6':
          return this.$t('timeframe.last_6_months');

        case 'months_12':
          return this.$t('timeframe.last_12_months');

        case 'custom':
          return this.$t('timeframe.custom');
      }
    }
  }
};